import React, { Component } from 'react';
import {
  Button,
  Form,
  Dropdown,
  Divider,
  TextArea,
  Grid,
  Loader,
  Icon,
  Label
} from 'semantic-ui-react';
import _ from 'lodash';

import {
  insertAdPrototype,
  updateAdPrototype
} from '../../../services/AdPrototypeService';
import CallToAction from '../../../components/common/CallToAction';
import DescriptionVariables from '../../../components/common/DescriptionVariables';
import { insertTag } from './../../../../src/services/TagService';
import AdBuilderAdPreviewModal from './AdBuilderAdPreviewModal';
import AdBuilderWarningModal from './AdBuilderWarningModal';
import './AdBuilderDAA.css';

class AdBuilderDAA extends Component {
  state = {
    selectedTags: {},
    errorMessage: '',
    successMessage: '',
    processing: false,
    showMessageVariables: false,
    showTitleVariables: false,
    showNewsLinkDescVariables: false,
    campaigns: [],
    packages: [],
    form: {
      name: '',
      accountId: '',
      callToAction: 'LEARN_MORE',
      utm: '',
      title: '', // headline
      description: '', // news link description
      message: '', // text
      daaType: 'Still',
      pageId: '1067945359908634' // constellation agency FB page ID
    },
    showAdBuilderAdPreviewModal: false,
    currentAdPrototype: {},
    qcApproved: null,
    isWarningModalOpen: false
  };

  componentDidMount() {
    this.initializeTags();
    if (this.props.adPrototypeEdit) {
      this.initializeEdit(this.props.adPrototypeEdit);
    }
  }

  initializeTags = () => {
    if (this.props.tags) {
      this.setState({
        campaigns: this.getOptions(this.props.tags.campaign),
        packages: this.getOptions(this.props.tags.package)
      });
    }
  };

  initializeEdit = async (adPrototypeEdit) => {
    const form = this.state.form;
    form.name = adPrototypeEdit.name;
    form.accountId = adPrototypeEdit.client;
    form.utm = adPrototypeEdit.utm;
    form.message = adPrototypeEdit.message;
    form.callToAction = adPrototypeEdit.call_to_action;
    form.daaType = adPrototypeEdit.asset_id;
    form.title = adPrototypeEdit.title;
    // since footer_text / footerCopy is not used for anything in DAA ads,
    // it will be used as News Link Description for DAA links
    form.description = adPrototypeEdit.footer_text;
    const selectedTags = {
      corporate: [],
      oem: [],
      product: [],
      year: [],
      month: [],
      campaign: [],
      package: []
    };

    adPrototypeEdit.tags.forEach((tag) => {
      selectedTags[tag.category].push(tag.tag_id);
    });

    this.setState({ form, selectedTags });
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  onAccountSelect = async (event, data) => {
    const account = _.find(data.options, (option) => {
      return option.value === data.value;
    });
    const accountId = account.value;
    const form = this.state.form;
    form.accountId = accountId;

    this.setState({ form });
  };

  addVariable = (e, data) => {
    const { form } = this.state;
    const { options, value, id } = data;
    const variable = _.find(options, (option) => option.value === value);
    const newForm = { ...form };

    switch (id) {
      case 'titleVariables':
        newForm.title += variable.value;
        break;
      case 'messageVariables':
        newForm.message += variable.value;
        break;
      case 'descriptionVariables':
        newForm.description += variable.value;
        break;
      default:
        break;
    }

    this.setState((prevState) => ({ ...prevState, form: newForm }));
  };

  onCallToActionSelect = (e, data) => {
    const call = _.find(data.options, (option) => option.value === data.value);

    const form = this.state.form;
    form.callToAction = call.value;

    this.setState({ form });
  };

  onSearchTagsSelect = (e, data) => {
    const { id: category, value: selectedSearchKeys, options } = data;

    const tags = options.filter(
      (option) => selectedSearchKeys.indexOf(option.key) !== -1
    );

    const tagOptionKeys = tags.map((tag) => tag.key);

    this.setState((prevState) => ({
      ...prevState,
      selectedTags: {
        ...prevState.selectedTags,
        [category]: tagOptionKeys
      }
    }));
  };

  getOptions = (tags) => {
    if (!tags) {
      return [];
    }

    const options = tags.map((tag) => ({
      key: tag.id,
      value: tag.id,
      text: tag.value,
      category: tag.category
    }));

    return options;
  };

  getSelectedTags = () => {
    const selectedTags = this.state.selectedTags;
    let tags = [];

    if (selectedTags.corporate) {
      tags = tags.concat(selectedTags.corporate);
    }

    if (selectedTags.oem) {
      tags = tags.concat(selectedTags.oem);
    }

    if (selectedTags.product) {
      tags = tags.concat(selectedTags.product);
    }

    if (selectedTags.year) {
      tags = tags.concat(selectedTags.year);
    }

    if (selectedTags.month) {
      tags = tags.concat(selectedTags.month);
    }

    if (selectedTags.campaign) {
      tags = tags.concat(selectedTags.campaign);
    }

    if (selectedTags.package) {
      tags = tags.concat(selectedTags.package);
    }

    return tags;
  };

  saveAdPrototype = async () => {
    const { adPrototypeEdit, searchPage, user } = this.props;
    const { qcApproved, form } = this.state;
    const {
      name,
      utm,
      title,
      description,
      message,
      accountId,
      callToAction,
      daaType
    } = form;

    this.setState(
      { errorMessage: '', successMessage: '', processing: true },
      async () => {
        const adPrototypeData = {
          name,
          utm,
          title,
          message,
          resource_id: null,
          type: 'DAA',
          video: '',
          thumbnail: '',
          client: accountId,
          tags: this.getSelectedTags(),
          asset_id: daaType,
          call_to_action: callToAction,
          footerCopy: description,
          qc_approved:
            typeof qcApproved === 'boolean'
              ? qcApproved
              : adPrototypeEdit.qc_approved,
          created_by: user.email
        };

        if (adPrototypeEdit) {
          adPrototypeData.id = adPrototypeEdit.id;
        }

        const result = !adPrototypeEdit
          ? await insertAdPrototype(adPrototypeData)
          : await updateAdPrototype(adPrototypeData);

        if (result.statusCode === 200) {
          const successMessage = !adPrototypeEdit
            ? 'The DAA Ad has been created'
            : 'The DAA Ad has been updated';
          const { adPrototypeId } = result;
          adPrototypeData.id = adPrototypeId;
          this.setState(
            {
              successMessage,
              processing: false,
              currentAdPrototype: adPrototypeData
            },
            () => {
              if (!adPrototypeEdit && searchPage) {
                searchPage();
              }
            }
          );
        } else {
          this.setState({
            errorMessage: 'There was an error saving the DAA Ad',
            processing: false
          });
        }
      }
    );
  };

  clearTags = () => {
    const form = this.state.form;
    form.accountId = '';
    this.setState({ selectedTags: {}, form });
  };

  showVariables = (id) => {
    const value = this.state[id];
    this.setState({ [id]: !value });
  };

  onAddTag = (event, { category, value, options }) => {
    this.addTagOnceConfirmed({ category, value, options });
  };

  addTagOnceConfirmed = ({ category, value }) => {
    const { user } = this.props;

    const { email } = user || {};

    const isRequired =
      ['oem', 'type', 'year', 'product', 'language', 'condition'].indexOf(
        category
      ) > -1;

    const tag = {
      category,
      required: isRequired,
      value,
      created_by: email
    };

    insertTag(tag).then((result) => {
      const { statusCode, tag: addedTag } = result;

      if (statusCode === 200) {
        const { id } = addedTag || {};

        const newTagOption = {
          key: id,
          text: value,
          value: id,
          category
        };

        if (category === 'campaign') {
          const { campaigns } = this.state;
          campaigns.push(newTagOption);
          this.setState({ campaigns });
        } else if (category === 'package') {
          const { packages } = this.state;
          packages.push(newTagOption);
          this.setState({ packages });
        }
      }
    });
  };

  toggleAdBuilderAdPreviewModal = () => {
    const { showAdBuilderAdPreviewModal } = this.state;
    this.setState((prevState) => ({
      ...prevState,
      showAdBuilderAdPreviewModal: !showAdBuilderAdPreviewModal
    }));
  };

  updateAdPrototypeForQc = (qcBool) => {
    this.setState((prevState) => ({
      ...prevState,
      qcApproved: qcBool
    }));
  };

  toggleWarningModal = () => {
    const { isWarningModalOpen } = this.state;
    this.setState({ ...this.state, isWarningModalOpen: !isWarningModalOpen });
  };

  render() {
    const { adPrototypeEdit, getFbToken } = this.props;
    const {
      form,
      selectedTags,
      processing,
      errorMessage,
      successMessage,
      showTitleVariables,
      showMessageVariables,
      showNewsLinkDescVariables,
      campaigns,
      packages,
      showAdBuilderAdPreviewModal,
      currentAdPrototype,
      qcApproved: qcApprovedState,
      isWarningModalOpen
    } = this.state;
    const {
      name,
      accountId,
      utm,
      callToAction,
      daaType,
      pageId,
      title,
      message,
      description
    } = form;
    const modalFields = { name, message, title, description };
    const missingFieldKeys = Object.keys(modalFields).filter(
      (key) => !form[key]
    );
    const { tags, accounts } = this.props;
    const adPrototypeForPreview = currentAdPrototype.id
      ? currentAdPrototype
      : adPrototypeEdit;
    const { qc_approved: qcApprovedProp } = adPrototypeForPreview || {};
    const qcApproved =
      typeof qcApprovedState === 'boolean' ? qcApprovedState : qcApprovedProp;

    return (
      <div>
        {processing ? (
          <div>
            <span>
              <Loader inline className="active" />
              Processing...
            </span>
          </div>
        ) : null}
        <div className="daa-builder-message-container">
          {errorMessage ? (
            <div>
              <Label basic color="red" className="canvas-builder-error">
                {errorMessage}
              </Label>
            </div>
          ) : null}
          {successMessage ? (
            <div>
              <Label basic color="green" className="canvas-builder-message">
                {successMessage}
              </Label>
            </div>
          ) : null}
        </div>
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column>
              <Button onClick={this.props.searchPage} size="small" color="grey">
                Back
              </Button>
              <Button
                onClick={() => {
                  if (missingFieldKeys.length > 0) {
                    this.toggleWarningModal();
                  } else {
                    this.saveAdPrototype();
                  }
                }}
                size="small"
                color="blue"
              >
                Save
              </Button>
              <h1>
                {!adPrototypeEdit && 'NEW '} DAA AD{' '}
                {daaType ? ` - ${daaType}` : ''}
              </h1>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column width={6}>
                    <Form.Input
                      placeholder="Name"
                      type="text"
                      name="name"
                      value={name}
                      onChange={this.handleFormChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={4} className="daa-builder-tag-button">
                    <Button onClick={this.clearTags} size="small" color="green">
                      Clear Tags
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider hidden />
              <Dropdown
                placeholder="Model/Product"
                search
                multiple
                selection
                allowAdditions
                id="product"
                category="product"
                value={selectedTags.product ? selectedTags.product : []}
                className="daa-builder-multiple-tags"
                options={this.getOptions(tags.product)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Year"
                search
                multiple
                selection
                allowAdditions
                id="year"
                category="year"
                value={selectedTags.year ? selectedTags.year : []}
                className="daa-builder-multiple-tags"
                options={this.getOptions(tags.year)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="OEM"
                search
                multiple
                selection
                allowAdditions
                id="oem"
                category="oem"
                value={selectedTags.oem ? selectedTags.oem : []}
                className="daa-builder-multiple-tags"
                options={this.getOptions(tags.oem)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Client"
                search
                selection
                value={accountId}
                options={accounts}
                onChange={this.onAccountSelect}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Campaign"
                search
                multiple
                selection
                allowAdditions
                id="campaign"
                category="campaign"
                value={selectedTags.campaign ? selectedTags.campaign : []}
                className="canvas-builder-multiple-tags"
                options={campaigns}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Campaign Month"
                search
                multiple
                selection
                allowAdditions
                id="month"
                category="month"
                value={selectedTags.month ? selectedTags.month : []}
                className="canvas-builder-multiple-tags"
                options={this.getOptions(tags.month)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Package"
                search
                multiple
                selection
                allowAdditions
                id="package"
                category="package"
                value={selectedTags.package ? selectedTags.package : []}
                className="canvas-builder-multiple-tags"
                options={packages}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Corporate Target"
                search
                multiple
                selection
                allowAdditions
                id="corporate"
                category="corporate"
                value={selectedTags.corporate ? selectedTags.corporate : []}
                className="daa-builder-multiple-tags"
                options={this.getOptions(tags.corporate)}
                onChange={this.onSearchTagsSelect}
                onAddItem={this.onAddTag}
              />
              <Divider hidden />
              <Divider hidden />
              <TextArea
                className="daa-builder-textarea"
                placeholder="UTM Code"
                name="utm"
                rows="5"
                value={utm}
                onChange={this.handleFormChange}
              />
            </Grid.Column>
            <Grid.Column>
              <Button.Group>
                <Button
                  active={daaType === 'Still'}
                  onClick={() => {
                    this.setState({
                      form: { ...this.state.form, daaType: 'Still' }
                    });
                  }}
                >
                  Still
                </Button>
                <Button
                  active={daaType === 'Carousel'}
                  onClick={() => {
                    this.setState({
                      form: { ...this.state.form, daaType: 'Carousel' }
                    });
                  }}
                >
                  Carousel
                </Button>
              </Button.Group>
              <Divider hidden />
              <Dropdown
                placeholder="Call To Action"
                search
                selection
                id="callToAction"
                value={callToAction}
                options={CallToAction}
                onChange={this.onCallToActionSelect}
              />
              <Divider hidden />
              <div className="daa-builder-variables-section">
                <TextArea
                  className="daa-builder-textarea"
                  placeholder="Text"
                  name="message"
                  rows="5"
                  value={message}
                  onChange={this.handleFormChange}
                />
                <a
                  role="button"
                  tabIndex={0}
                  className="daa-builder-plus-icon"
                  onClick={() => this.showVariables('showMessageVariables')}
                >
                  <Icon size="big" name="plus circle" />
                </a>
                {showMessageVariables ? (
                  <Dropdown
                    className="daa-builder-variables-options"
                    placeholder="Variables"
                    search
                    selection
                    id="messageVariables"
                    options={DescriptionVariables}
                    onChange={this.addVariable}
                  />
                ) : null}
              </div>
              <Divider hidden />
              <div className="daa-builder-variables-section">
                <TextArea
                  className="daa-builder-textarea"
                  placeholder="Headline"
                  name="title"
                  rows="5"
                  value={title}
                  onChange={this.handleFormChange}
                />
                <a
                  role="button"
                  tabIndex={0}
                  className="daa-builder-plus-icon"
                  onClick={() => this.showVariables('showTitleVariables')}
                >
                  <Icon size="big" name="plus circle" />
                </a>
                {showTitleVariables ? (
                  <Dropdown
                    className="daa-builder-variables-options"
                    placeholder="Variables"
                    search
                    selection
                    id="titleVariables"
                    options={DescriptionVariables}
                    onChange={this.addVariable}
                  />
                ) : null}
              </div>
              <Divider hidden />
              <div className="daa-builder-variables-section">
                <TextArea
                  className="daa-builder-textarea"
                  placeholder="News Link Description"
                  name="description"
                  rows="5"
                  value={description}
                  onChange={this.handleFormChange}
                />
                <a
                  role="button"
                  tabIndex={0}
                  className="daa-builder-plus-icon"
                  onClick={() =>
                    this.showVariables('showNewsLinkDescVariables')
                  }
                >
                  <Icon size="big" name="plus circle" />
                </a>
                {showNewsLinkDescVariables ? (
                  <Dropdown
                    className="daa-builder-variables-options"
                    placeholder="Variables"
                    search
                    selection
                    id="descriptionVariables"
                    options={DescriptionVariables}
                    onChange={this.addVariable}
                  />
                ) : null}
              </div>
            </Grid.Column>
            <Grid.Column>
              <AdBuilderAdPreviewModal
                showAdBuilderAdPreviewModal={showAdBuilderAdPreviewModal}
                toggleAdBuilderAdPreviewModal={
                  this.toggleAdBuilderAdPreviewModal
                }
                adPrototypeEdit={adPrototypeForPreview}
                adType={'DAA'}
                pageId={pageId}
                getFbToken={getFbToken}
                updateAdPrototypeForQc={this.updateAdPrototypeForQc}
                inEditor
              />
              <AdBuilderWarningModal
                formKeys={missingFieldKeys}
                isWarningModalOpen={isWarningModalOpen}
                toggleWarningModal={this.toggleWarningModal}
                saveAdPrototype={() => {
                  this.setState(
                    { ...this.state, isWarningModalOpen: false },
                    () => {
                      this.saveAdPrototype();
                    }
                  );
                }}
              />
              <Button
                disabled={!adPrototypeForPreview}
                color="facebook"
                onClick={this.toggleAdBuilderAdPreviewModal}
              >
                View Ad Preview
              </Button>
              <Divider hidden />
              {typeof qcApproved === 'boolean' ? (
                <Label
                  size="large"
                  color={qcApproved ? 'green' : 'red'}
                  content={`QC: ${qcApproved ? 'Approved' : 'Denied'}`}
                />
              ) : (
                <Label color="grey" content="QC: No status" />
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

export default AdBuilderDAA;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdBuilderDAA.js